import { render } from "./SidebarTrigger.vue?vue&type=template&id=996a0836&ts=true"
import script from "./SidebarTrigger.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarTrigger.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarTrigger.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "996a0836"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('996a0836', __exports__)) {
    api.reload('996a0836', __exports__)
  }
  
  module.hot.accept("./SidebarTrigger.vue?vue&type=template&id=996a0836&ts=true", () => {
    api.rerender('996a0836', render)
  })

}


export default __exports__